import { render, staticRenderFns } from "./SiteFormsSidebar.vue?vue&type=template&id=0abb16d0"
import script from "./SiteFormsSidebar.vue?vue&type=script&lang=js"
export * from "./SiteFormsSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports